export const ENV = process.env.REACT_APP_ENV || 'dev';
export const SSO_HOST = process.env.REACT_APP_SSO_HOST || 'https://dev.loginproxy.gov.bc.ca/auth';
export const SSO_REALM = process.env.REACT_APP_SSO_REALM || 'standard';
export const SSO_CLIENT = process.env.REACT_APP_SSO_CLIENT || 'saw-sx-5132';
export const SM_LOGOFF_URL = process.env.REACT_APP_SM_LOGOFF_URL || 'https://logontest7.gov.bc.ca/clp-cgi/logoff.cgi/';
export const DEPLOYMENT_TAG = process.env.REACT_APP_DEPLOYMENT_TAG || '';
export const DEPLOYMENT_TIME = process.env.REACT_APP_DEPLOYMENT_TIME || '';
export const STYLE_NONCE = process.env.REACT_APP_STYLE_NONCE || '';
